import React from "react";
import { Link } from "react-router-dom";

const Personal = () => {
  return (
    <>
      <div className="personal-space">
        <div className="personal-sub">
          <h1 className="personal-title">Vår personal </h1>
          <p className="personal-text">
            Vi är en byggmästare med ett team av 10 skickliga och erfarna
            hantverkare. Den samlade kompetensen inom vårt företag gör oss till
            en ledande aktör i branschen och en pålitlig partner för dig som
            planerar en renovering i Söder Renovering eller söker andra
            byggtjänster.
            <br />
            <br />
            Med över 10 års erfarenhet inom byggbranschen har vi utvecklat en
            djup förståelse för alla aspekter av bygg- och renoveringsprojekt.
            Vår kunskap och vårt engagemang säkerställer att varje projekt
            genomförs med högsta kvalitet och precision – en trygghet
            för dig som kund.
          </p>

          <Link to={"/services"} className="reg-btn border-0">
            Gratis offert
          </Link>
        </div>
      </div>
    </>
  );
};

export default Personal;
